import {
  GET_BRAND_REQUEST,
  GET_BRAND_SUCCESS,
  GET_BRAND_FAIL,
  LIST_BRANDS_REQUEST,
  LIST_BRANDS_SUCCESS,
  LIST_BRANDS_FAIL,
  SEARCH_BRANDS_REQUEST,
  SEARCH_BRANDS_SUCCESS,
  SEARCH_BRANDS_FAIL,
  UPDATE_BRAND_PROFILE_REQUEST,
  UPDATE_BRAND_PROFILE_SUCCESS,
  UPDATE_BRAND_PROFILE_FAIL,
  LIST_BRAND_PAID_EVENTS_REQUEST,
  LIST_BRAND_PAID_EVENTS_SUCCESS,
  LIST_BRAND_PAID_EVENTS_FAIL,
  GET_BILLING_DETAILS_REQUEST,
  GET_BILLING_DETAILS_SUCCESS,
  GET_BILLING_DETAILS_FAIL,
  SAVE_BILLING_DETAILS_REQUEST,
  SAVE_BILLING_DETAILS_SUCCESS,
  SAVE_BILLING_DETAILS_FAIL,
} from '../actions/brands';
import { LOGOUT } from '../actions/auth';

const initialState = {
  brand: null,
  brands: [],
  brandsPagination: null,
  loading: false,
  error: null,
  searchPagination: null,
  searchLoading: false,
  searchResults: null,
  paidEvents: [],
  paidEventsLoading: false,
  paidEventsError: null,
  // Own-account billing identity — see fetchBrandBillingDetails. `loaded`
  // distinguishes "never fetched" from "fetched and genuinely empty", so the
  // checkout pre-fill doesn't refetch on every booking card.
  billingDetails: null,
  billingDetailsLoaded: false,
  billingDetailsLoading: false,
  billingDetailsSaving: false,
  billingDetailsError: null,
};

const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        brand: null,
      };
    case GET_BRAND_SUCCESS:
      return {
        ...state,
        brand: action.payload,
        loading: false,
        error: null,
      };
    case GET_BRAND_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LIST_BRANDS_REQUEST: {
      const append = Boolean(action.meta?.append);
      return {
        ...state,
        loading: true,
        error: null,
        ...(append
          ? {}
          : {
              brands: [],
              brandsPagination: null,
              searchResults: null,
              searchPagination: null,
              searchLoading: false,
            }),
      };
    }
    case LIST_BRANDS_SUCCESS: {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        return {
          ...state,
          brands: payload,
          brandsPagination: null,
          loading: false,
          error: null,
        };
      }
      const { data = [], pagination = null, append = false } = payload || {};
      return {
        ...state,
        brands: append ? [...state.brands, ...data] : data,
        brandsPagination: pagination,
        loading: false,
        error: null,
      };
    }
    case LIST_BRANDS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEARCH_BRANDS_REQUEST: {
      const append = Boolean(action.meta?.append);
      return {
        ...state,
        searchLoading: true,
        error: null,
        ...(append ? {} : { searchResults: [], searchPagination: null }),
      };
    }
    case SEARCH_BRANDS_SUCCESS: {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        return {
          ...state,
          searchResults: payload,
          searchPagination: null,
          searchLoading: false,
          error: null,
        };
      }
      const { data = [], pagination = null, append = false } = payload || {};
      return {
        ...state,
        searchResults: append
          ? [...(state.searchResults ?? []), ...data]
          : data,
        searchPagination: pagination,
        searchLoading: false,
        error: null,
      };
    }
    case SEARCH_BRANDS_FAIL:
      return {
        ...state,
        searchLoading: false,
        error: action.payload,
      };
    case UPDATE_BRAND_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BRAND_PROFILE_SUCCESS:
      return {
        ...state,
        brand: action.payload,
        loading: false,
        error: null,
      };
    case UPDATE_BRAND_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LIST_BRAND_PAID_EVENTS_REQUEST:
      return {
        ...state,
        paidEventsLoading: true,
        paidEventsError: null,
        paidEvents: [],
      };
    case LIST_BRAND_PAID_EVENTS_SUCCESS:
      return {
        ...state,
        paidEvents: action.payload,
        paidEventsLoading: false,
        paidEventsError: null,
      };
    case LIST_BRAND_PAID_EVENTS_FAIL:
      return {
        ...state,
        paidEventsLoading: false,
        paidEventsError: action.payload,
      };
    case GET_BILLING_DETAILS_REQUEST:
      return {
        ...state,
        billingDetailsLoading: true,
        billingDetailsError: null,
      };
    case GET_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        billingDetails: action.payload,
        billingDetailsLoaded: true,
        billingDetailsLoading: false,
        billingDetailsError: null,
      };
    case GET_BILLING_DETAILS_FAIL:
      return {
        ...state,
        billingDetailsLoading: false,
        billingDetailsError: action.payload,
      };
    case SAVE_BILLING_DETAILS_REQUEST:
      return {
        ...state,
        billingDetailsSaving: true,
        billingDetailsError: null,
      };
    case SAVE_BILLING_DETAILS_SUCCESS:
      return {
        ...state,
        billingDetails: action.payload,
        billingDetailsLoaded: true,
        billingDetailsSaving: false,
        billingDetailsError: null,
      };
    case SAVE_BILLING_DETAILS_FAIL:
      return {
        ...state,
        billingDetailsSaving: false,
        billingDetailsError: action.payload,
      };
    // Tax id and address are personal data and the store outlives a logout in
    // the same tab — drop them so the next account never sees them.
    case LOGOUT:
      return {
        ...state,
        billingDetails: null,
        billingDetailsLoaded: false,
        billingDetailsLoading: false,
        billingDetailsSaving: false,
        billingDetailsError: null,
      };
    default:
      return state;
  }
};

export default brandReducer;
